// src/stone/icons/Link2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Link2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M21.755 5.064A9.333 9.333 0 0 1 34.953 18.26l-.013.013-5 5a9.333 9.333 0 0 1-14.074-1.009 1 1 0 1 1 1.601-1.197 7.335 7.335 0 0 0 11.059.792l4.994-4.994A7.333 7.333 0 0 0 23.15 6.498l-2.862 2.844a1 1 0 0 1-1.41-1.418l2.867-2.85z" }),
      /* @__PURE__ */ jsx("path", { d: "M13.398 14.58a9.33 9.33 0 0 1 10.736 3.154 1 1 0 0 1-1.602 1.198 7.333 7.333 0 0 0-11.058-.792L6.48 23.134a7.333 7.333 0 0 0 10.37 10.37l2.843-2.844a1 1 0 0 1 1.414 1.414l-2.85 2.85-.012.012A9.333 9.333 0 0 1 5.047 21.739l.012-.013 5-5a9.3 9.3 0 0 1 3.34-2.146" })
    ]
  }
);
var Link2X_default = Link2X;

export {
  Link2X_default
};
